import { initializeApp, getApps, getApp, FirebaseApp, FirebaseOptions } from 'firebase/app';

/**
 * Returns the already-initialized default Firebase app if one exists,
 * otherwise initializes it.
 *
 * `initializeApp()` throws if called twice for the default ('[DEFAULT]') app,
 * but FirebaseAuthService and RemoteConfigService both need a handle on the
 * SAME app instance - and, for the internal build, the pre-bootstrap gate in
 * main.ts also initializes the app before any Angular service exists. Any of
 * these three call sites might run first depending on build/DI timing, so
 * they all go through this helper instead of calling `initializeApp` raw.
 */
export function getOrInitFirebaseApp(config: FirebaseOptions): FirebaseApp {
  const existing = getApps();
  return existing.length ? getApp() : initializeApp(config);
}
